export function getProfileImagePosition(user) {
  const x = Number(user?.profile_image_focus_x);
  const y = Number(user?.profile_image_focus_y);

  const safeX = Number.isFinite(x) ? Math.min(Math.max(x, 0), 100) : 50;
  const safeY = Number.isFinite(y) ? Math.min(Math.max(y, 0), 100) : 50;

  return `${safeX}% ${safeY}%`;
}

export function getProfileImageStyle(user) {
  return {
    objectPosition: getProfileImagePosition(user)
  };
}
